import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { statConstants, statModels } from '..';

export const useStatCallHistoryLeadTable = (
  props: {
    callType?: string | null;
    startDate?: number;
    finishDate?: number;
    fieldId?: number | null;
    fieldValue?: string;
    tagId?: number;
    page?: number;
    size?: number;
    employeeId?: number[] | null | undefined;
    pipeId?: number | null;
    statuses?: string[];
    durationStart?: number | null;
    durationFinish?: number | null;
    talkTimeStart?: number | null;
    talkTimeFinish?: number | null;
  } = {}
) =>
  useQuery<Pagination<statModels.ICallHistoryLeadTable>>({
    queryKey: [statConstants.queryKeys.STAT_CALL_HISTORY_LEAD_TABLE, props],
    queryFn: async () => {
      const res = await $api.post('/v1/stat/call-history/lead-table', props);

      return res?.data?.data;
    },
    enabled: !!props?.fieldId || !!props?.tagId
  });
